import React from "react";
import { cn } from "@/lib/utils";

const MAP = {
  Active: "bg-emerald-500/15 text-emerald-500 border-emerald-500/30",
  Valid: "bg-emerald-500/15 text-emerald-500 border-emerald-500/30",
  Reissued: "bg-amber-500/15 text-amber-500 border-amber-500/30",
  Revoked: "bg-rose-500/15 text-rose-500 border-rose-500/30",
  Inactive: "bg-slate-500/15 text-slate-400 border-slate-500/30",
  Suspended: "bg-rose-500/15 text-rose-500 border-rose-500/30",
  Paid: "bg-emerald-500/15 text-emerald-500 border-emerald-500/30",
  Pending: "bg-amber-500/15 text-amber-500 border-amber-500/30",
  Processed: "bg-blue-500/15 text-blue-500 border-blue-500/30",
  "Partially Paid": "bg-amber-500/15 text-amber-500 border-amber-500/30",
  Overdue: "bg-rose-500/15 text-rose-500 border-rose-500/30",
  Approved: "bg-emerald-500/15 text-emerald-500 border-emerald-500/30",
  "Under Review": "bg-violet-500/15 text-violet-400 border-violet-500/30",
  Issued: "bg-blue-500/15 text-blue-500 border-blue-500/30",
  Returned: "bg-slate-500/15 text-slate-400 border-slate-500/30",
  Credited: "bg-emerald-500/15 text-emerald-500 border-emerald-500/30",
  Available: "bg-emerald-500/15 text-emerald-500 border-emerald-500/30",
  Assigned: "bg-blue-500/15 text-blue-500 border-blue-500/30",
};

export function StatusBadge({ status, className }) {
  const cls = MAP[status] || "bg-muted text-muted-foreground border-border";
  return (
    <span data-testid={`status-${String(status).toLowerCase().replace(/\s+/g, "-")}`}
      className={cn("inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold", cls, className)}>
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {status}
    </span>
  );
}
